import {TrackingService} from "@app/core/tracking/domain/repositories/tracking.service";
import {TrackAddToCartDTO} from "@app/core/tracking/domain/dtos/track-add-to-cart.dto";
import {Injectable} from "@angular/core";
import {WindowService} from "@app/core/shared/domain/window.service";
import {TrackAddToCartDtoMapper} from "@app/core/tracking/infrastructure/mappers/track-add-to-cart-dto.mapper";
import {TrackAddShippingInfoDto} from "@app/core/tracking/domain/dtos/track-add-shipping-info.dto";
import {TackBeginCheckoutDto} from "@app/core/tracking/domain/dtos/tack-begin-checkout.dto";
import {
    TrackAddShippingInfoDtoMapper
} from "@app/core/tracking/infrastructure/mappers/track-add-shipping-info-dto.mapper";
import {TrackBeginCheckoutDtoMapper} from "@app/core/tracking/infrastructure/mappers/track-begin-checkout-dto.mapper";
import {TrackViewItemDto} from "@app/core/tracking/domain/dtos/track-view-item.dto";
import {TrackViewItemDtoMapper} from "@app/core/tracking/infrastructure/mappers/track-view-item-dto.mapper";
import {TrackViewPromotionDto} from "@app/core/tracking/domain/dtos/track-view-promotion.dto";
import {TrackViewPromotionDtoMapper} from "@app/core/tracking/infrastructure/mappers/track-view-promotion-dto.mapper";
import {TrackViewItemListDto} from "@app/core/tracking/domain/dtos/track-view-item-list.dto";
import {TrackViewItemListDtoMapper} from "@app/core/tracking/infrastructure/mappers/track-view-item-list-dto.mapper";
import {TrackPurchaseDto} from "@app/core/tracking/domain/dtos/track-purchase.dto";
import {TrackPurchaseDtoMapper} from "@app/core/tracking/infrastructure/mappers/track-purchase-dto.mapper";
import {TrackAddPaymentInfoDto} from "@app/core/tracking/domain/dtos/track-add-payment-info.dto";
import {
    TrackAddPaymentInfoDtoMapper
} from "@app/core/tracking/infrastructure/mappers/track-add-payment-info-dto.mapper";
import {TrackAddToWishlistDto} from "@app/core/tracking/domain/dtos/track-add-to-wishlist.dto";
import {TrackAddToWishlistDtoMapper} from "@app/core/tracking/infrastructure/mappers/track-add-to-wishlist-dto.mapper";
import {TrackRemoveFromCartDto} from "@app/core/tracking/domain/dtos/track-remove-from-cart.dto";
import {
    TrackRemoveFromCartDtoMapper
} from "@app/core/tracking/infrastructure/mappers/track-remove-from-cart-dto.mapper";
import {TrackSelectItemDto} from "@app/core/tracking/domain/dtos/track-select-item.dto";
import {TrackSelectItemDtoMapper} from "@app/core/tracking/infrastructure/mappers/track-select-item-dto.mapper";
import {UserLocal} from "@app/core/user/domain/user.local";

@Injectable()
export class GTMTrackingService implements TrackingService{

    constructor(
       private windowService:WindowService,
       private userLocal: UserLocal,
    ) {}

    private push(event: string,data: any): void {
        const window = this.windowService.getWindow() as any;
        if (window) {
            const email = this.userLocal.getUser()?.email;
            window.dataLayer.push({
                event: event,
                ecommerce: data,
                userInfo: {
                    email: email
                }
            })
        }
    }

    addToCart(dto: TrackAddToCartDTO): void {
        this.push('add_to_cart', TrackAddToCartDtoMapper.serialize(dto));
    }

    addShippingInfo(dto: TrackAddShippingInfoDto): void {
        this.push('add_shipping_info', TrackAddShippingInfoDtoMapper.serialize(dto));
    }

    beginCheckout(dto: TackBeginCheckoutDto): void {
        this.push('begin_checkout', TrackBeginCheckoutDtoMapper.serialize(dto));
    }

    viewItem(dto: TrackViewItemDto): void {
        this.push('view_item',TrackViewItemDtoMapper.serialize(dto));
    }

    viewPromotion(dto: TrackViewPromotionDto): void {
        this.push('view_promotion', TrackViewPromotionDtoMapper.serialize(dto));
    }

    viewItemList(dto: TrackViewItemListDto): void {
        this.push('view_item_list', TrackViewItemListDtoMapper.serialize(dto));
    }

    purchase(dto: TrackPurchaseDto): void {
        this.push('purchase', TrackPurchaseDtoMapper.serialize(dto));
    }

    selectPromotion(dto: TrackViewPromotionDto): void {
        this.push('select_promotion', TrackViewPromotionDtoMapper.serialize(dto));
    }

    addPaymentInfo(dto: TrackAddPaymentInfoDto): void {
        this.push('add_payment_info', TrackAddPaymentInfoDtoMapper.serialize(dto));
    }

    signUp(): void {
        this.push('sign_up', {});
    }

    addToWishlist(dto: TrackAddToWishlistDto): void {
        this.push('add_to_wishlist', TrackAddToWishlistDtoMapper.serialize(dto));
    }

    removeFromCart(dto: TrackRemoveFromCartDto): void {
        this.push('remove_from_cart', TrackRemoveFromCartDtoMapper.serialize(dto));
    }

    selectItem(dto: TrackSelectItemDto): void {
        this.push('select_item', TrackSelectItemDtoMapper.serialize(dto));
    }
    
}
